export function hideSingleSlideControls() {
    const sliders = document.querySelectorAll(
        '.elementor-widget-loop-carousel'
    );
    sliders.forEach((slider) => {
        const hasMultipleSlides = slider.querySelector(
            '.swiper-slide + .swiper-slide'
        );

        // If there is NOT more than one slide
        if (!hasMultipleSlides) {
            const swiperButtons = slider.querySelectorAll(
                '.elementor-swiper-button'
            );
            swiperButtons.forEach((button) => {
                // Use a more direct style manipulation
                button.classList.add('hidden'); // Add a class instead of inline style
            });
        }
    });
}
